<script setup>
const props = defineProps({
  video: {
    type: Object,
    required: true,
  },
  autoplay: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <video
    class="video"
    controls
    :autoplay="props.autoplay"
    :muted="props.autoplay"
  >
    <source
      :src="props.video?.src"
      :type="props.video?.type"
    >
    Your browser does not support HTML video.
  </video>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.video {
  width: 100%;
  height: 100%;
}
</style>
